var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUndo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53033 3.53033C9.82322 3.23744 9.82322 2.76256 9.53033 2.46967C9.23744 2.17678 8.76256 2.17678 8.46967 2.46967L3.21967 7.71967C3.07902 7.86032 3 8.05109 3 8.25C3 8.44891 3.07902 8.63968 3.21967 8.78033L8.46967 14.0303C8.76257 14.3232 9.23744 14.3232 9.53033 14.0303C9.82322 13.7374 9.82322 13.2625 9.53033 12.9696L5.56067 9H16.248C17.11 9 17.9366 9.34241 18.5461 9.9519C19.1556 10.5614 19.498 11.388 19.498 12.25V20.25C19.498 20.6642 19.8338 21 20.248 21C20.6622 21 20.998 20.6642 20.998 20.25V12.25C20.998 10.9902 20.4976 9.78204 19.6068 8.89124C18.716 8.00044 17.5078 7.5 16.248 7.5H5.56066L9.53033 3.53033Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUndo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/undo.2425a98a38b4c3bdf42b97d82e4effd6.svg";